import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, semantic, space } from '../../theme/tokens';

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[3]} ${space['20px']};
  gap: ${space[4]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[5]} ${space[7]};
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const FooterTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;
